var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

import React from "react";
export default (function (props) {
  var children = props.children,
      _props$size = props.size,
      size = _props$size === undefined ? "m" : _props$size,
      className = props.className,
      rest = _objectWithoutProperties(props, ["children", "size", "className"]);

  return React.createElement("button", _extends({
    className: "button button--style-default button--size-" + size + " button--color-blue-ribbon " + className
  }, rest), children);
});